import React from "react";
import axios from 'axios';
class Contactus1 extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            contact : []
        }
    }; 
    componentDidMount(){
      axios.get(encodeURI(process.env.REACT_APP_API_URL + 'api/resource/Web Page/contact-us'), {
          headers : { 
      'content-type': 'application/json'}
      })
      .then(response=>{
          //alert('ok')
          this.setState({contact:response.data['data']})
          console.log(response.data)  
      })
      .catch(response=>{
        
           //console.log(response+' api/resource/Item?fields=["name","item_group","standard_rate","image","description","item_code","item_name"]')
      })
  } 
  render() {
    const rawHTML =this.state.contact.main_section_html

    return <div dangerouslySetInnerHTML={{ __html: rawHTML }}/>
   

}
}

export default Contactus1;